import { jsx as _jsx } from "react/jsx-runtime";
import { SelectInputOptionContent } from '@transferwise/components';
import { Flag } from '@wise/art';
const CurrencySelectOption = ({ currencyCode, currencyName, }) => {
    return (_jsx(SelectInputOptionContent, { title: currencyCode, note: currencyName, icon: _jsx(Flag, { code: currencyCode, intrinsicSize: 24 }) }));
};
export default CurrencySelectOption;
